import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import CustomTable from "global/components/CustomTable/CustomTable";
import history from "utils/history";
import viewpaths from "global/constants/ViewPathConstants";
import { handleErrorMessage } from "helpers/methods";
import { fetchSharedRequests } from "../DocumentSharingServices";

/**
 * "Shared with me" — sign requests another user granted the current user read-only access to
 * (DOCUMENT_SHARE_GRANT). Read-only list; opening a row goes to the normal view-request screen.
 */
const SharedWithMeView = () => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const load = async () => {
    try {
      setLoading(true);
      // pageNo 0 intentionally returns ALL shared requests (the backend maps pageNo <= 0 to
      // DEFAULT_PAGE_SIZE = "ALL"), so this single call is complete — it is NOT an un-paginated
      // first page that silently drops later rows. Do not "fix" it by adding page iteration.
      const data = await fetchSharedRequests("All", 0);
      setRows(Array.isArray(data) ? data : []);
    } catch (error: any) {
      handleErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const ownerOf = (r: any) => {
    const rb = r?.requestedBy;
    if (rb && typeof rb === "object") return rb.name || rb.email || "";
    return rb || "";
  };

  const headers = [
    { name: "Subject", field: "subject", align: "left", sorting: false },
    { name: "Owner", field: "owner", align: "left", sorting: false },
    { name: "Status", field: "status", align: "left", sorting: false },
    { name: "Actions", field: "actions", align: "right", sorting: false },
  ];

  const tableRows = rows.map((r: any) => ({
    rowId: r.id,
    subject: r.emailSubject || r.title || r.name || "(untitled)",
    owner: ownerOf(r),
    status: r.status,
    actions: (
      <Button
        size="small"
        onClick={() =>
          history.push(`${viewpaths.viewRequestViewPath}/${r.id}`)
        }
      >
        View
      </Button>
    ),
  }));

  return (
    <Box sx={{ p: 1 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Shared with me
      </Typography>
      <CustomTable
        headers={headers}
        rows={tableRows}
        isLoading={loading}
        count={rows.length}
        showPagination={false}
        emptyMessage="No requests have been shared with you."
      />
    </Box>
  );
};

export default SharedWithMeView;
